<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('StockCirculation')" class="mt-2">
            <stock-circulation></stock-circulation>
          </vs-tab>
          <vs-tab :label="$t('SerialCirculation')" class="mt-2">
            <serial-circulation></serial-circulation>
          </vs-tab>
          <vs-tab :label="$t('WarehouseFinancialReport')" class="mt-2">
            <financial-report></financial-report>
          </vs-tab>
          <vs-tab :label="$t('SerialBalance')" class="mt-2">
            <serial-balance></serial-balance>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import StockCirculation from "./StockCirculation/Index.vue";
import SerialCirculation from "./SerialCirculation/Index.vue";
import SerialBalance from "./SerialBalance/Index.vue";
import FinancialReport from "./FinancialReport/Index.vue";

export default {
  name: "warehouseManagement_Reports_Index",
  components: {
    StockCirculation,
    SerialCirculation,
    SerialBalance,
    FinancialReport
  }
};
</script>
